var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoneNotHeardLeft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.1446 62.7574C59.2492 62.7637 60.1497 61.8734 60.156 60.7689L60.2587 42.7691C60.265 41.6646 59.3747 40.7641 58.2701 40.7578C57.1656 40.7515 56.2651 41.6418 56.2588 42.7463L56.1675 58.7461L40.1678 58.6548C39.0632 58.6485 38.1627 59.5388 38.1564 60.6434C38.1501 61.7479 39.0404 62.6484 40.1449 62.6547L58.1446 62.7574ZM33.2778 35.5938L31.8556 36.9999L56.7338 62.1636L58.1561 60.7574L59.5783 59.3513L34.7001 34.1876L33.2778 35.5938Z",
    fill: "#1265A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17L37 34.5L17 52",
    stroke: "#1265A1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoneNotHeardLeft);
export default __webpack_public_path__ + "static/media/BoneNotHeardLeft.742fc0d67c3a27aa6314eb78a09df4f5.svg";
export { ForwardRef as ReactComponent };